module.exports = __webpack_public_path__ + "static/media/CCLogo_Black.6d0e757c.jpg";